const { author } = require("../../package.json");

export const environment = {
  appName: "My Portfolio",
  author: author.name,
  email: author.email,
};
